import { createClient } from '@supabase/supabase-js';

// Supabase configuration with fallback to hardcoded values if env vars not available
// This ensures the app works in both development and production environments
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vfpajtgpxinvbkeripdd.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmcGFqdGdweGludmJrZXJpcGRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzOTA0ODcsImV4cCI6MjA1NTk2NjQ4N30.xO9O2MV7JVHXl81MvqnDXraNucAsWsWaD6sfTmqSNIA';

// Add some logging to help with debugging
if (!process.env.REACT_APP_SUPABASE_URL) {
  console.warn('REACT_APP_SUPABASE_URL environment variable not found, using fallback value');
}

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true
  },
  db: {
    schema: 'public'
  }
});
